import { useEffect } from 'react'
import { useSignupPageUpdate } from '@/services/onboardingService'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useAnalyticsView } from '@/features/amplitude'
import { fetchAnnualTaxFilingsIfNeeded } from '@/features/taxes/annual-taxes/annualTaxFilings.slice'
import { fetchAllAnnualTaxDetailsIfNeeded } from '@/features/admin/annual-tax-details/annualTaxDetails.slice'
import { selectAnnualTaxNotAvailable } from '@/features/taxes/annual-taxes/annualTaxFilings.selector'
import { SIGNUP_PATHS } from '../helpers'
import { Disqualified } from './Disqualified'
import { ActiveTaxForm } from './ActiveTaxForm'

export const PreviousYearTaxForm = () => {
  const dispatch = useAppDispatch()
  const pageView = useAnalyticsView()

  const isNotAvailable = useReselector(selectAnnualTaxNotAvailable)

  useEffect(() => {
    dispatch(fetchAllAnnualTaxDetailsIfNeeded())
    dispatch(fetchAnnualTaxFilingsIfNeeded())
  }, [dispatch])

  useEffect(() => {
    pageView('previous year tax form')
  }, [pageView])

  useSignupPageUpdate(SIGNUP_PATHS.previousYearTax)

  if (isNotAvailable) {
    return <Disqualified />
  } else {
    return <ActiveTaxForm />
  }
}
